// export { default } from './src/screens/Home';
import React from 'react';
import Home from './src/screens/home/Home';
import TestSVG from './src/screens/TestSVG';

const App = () => {
  return window.location.pathname === '/test' ? <TestSVG /> : <Home />
};

export default App;